<!--
  创建时间：2024/8/23 14:20
  创建人：toyehuang
  文件描述：PurchaseBlock 首页 项目信息模块
-->

<template>
  <div class="purchase-block mt-30 f-column-b">
    <div class="purchase-block-header f-b-c">
      <h4 :class="projectType">{{ projTypeItem[label] }}</h4>
      <ul class="f-start-c flex-1 ml-20">
        <li v-for="nt in noticeTypeList" :key="nt[code]" class="fc33 mr-20" :class="{active: nt[code] === noticeType}" @click="changeNoticeType(nt[code])">{{ nt[label] }}</li>
      </ul>
      <a :href="moreBtnUrl" class="a-btn" target="_blank">更多 &gt;</a>
    </div>
    <div class="list mt-20">
      <el-table
        v-if="list.length"
        class="project-table"
        height="100%"
        :data="list"
        fit
        :default-sort="{prop: 'endTime', order: null}"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @sort-change="handleSortChange"
        @row-click="rowClick"
      >
        <el-table-column label="项目名称" min-width="180">
          <template slot-scope="scope">
            <span class="text-cut" :title="scope.row.gonggaoTitle">{{ scope.row.gonggaoTitle }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseWayName" label="采购方式" width="150" />
        <el-table-column prop="endTime" label="截止时间" sortable="custom" width="180" />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <div class="table-btn" :style="{backgroundColor: ['1', '3'].includes(scope.row.status) ? '#DC4B19' : '#999'}">{{ scope.row.status_name }}</div>
          </template>
        </el-table-column>
      </el-table>
      <no-data v-else no-txt />
    </div>
  </div>
</template>

<script>
import {
  getConstantDic,
  INFO_TYPE_OPTIONS,
  PROJECT_STATUS_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
import purchaseApi from "@/api/purchase";
import NoData from "@/components/NoData.vue";

export default {
  name: "PurchaseBlock",
  components: { NoData },
  props: {
    projectType: {
      type: String,
      default: "GC"
    },
    desTxt: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      noticeTypeList: getConstantDic(INFO_TYPE_OPTIONS),
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: Object.values(PROJECT_STATUS_OPTIONS),
      noticeType: INFO_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE],
      code: SELECT_OPTION_CONFIG.CODE,
      label: SELECT_OPTION_CONFIG.LABEL,
      list: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    projTypeItem() {
      return PROJECT_TYPE_OPTIONS[this.projectType]
    },
    projTypeCode() {
      return this.projTypeItem[this.code]
    },
    moreBtnUrl() {
      return this.$router.resolve({ path: "/purchase/list/xmxx", query: { noticeType: this.noticeType, projectType: this.projTypeCode }})?.href
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList()
  },
  // 方法集合
  methods: {
    changeNoticeType(code) {
      this.noticeType = code
      this.getList()
    },
    // 获取列表
    getList() {
      const params = {
        pageNo: 1,
        pageSize: 6,
        projectType: this.projTypeCode,
        noticeType: this.noticeType,
        orderType: this.orderType || "default" // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
      }
      purchaseApi.page(params).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total || 0
          list.forEach(e => {
            e.status_name = this.statusList.find(f => f.code === e.status).label
          })
          this.list = data.list || []
        }
      })
    },
    headerCellStyle({ columnIndex }) {
      let str = "background-color: #f9f9f9;padding: 6.5px 0;"
      if (columnIndex === 0 || columnIndex === 3) {
        str += "text-align: center;"
      }
      return str
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "cursor:pointer;"
      if (columnIndex === 3) {
        str += "display: flex;justify-content: center;"
      }
      if (rowIndex === this.list.length - 1) {
        str += "border: none;"
      }
      return str
    },
    // 行点击
    rowClick(row) {
      const route = this.$router.resolve({
        path: "/purchase/detail/xmxx",
        query: {
          id: row.id,
          infoid: row.infoid,
          noticeType: this.noticeType
        }
      })
      window.open(route.href)
    },
    // 排序
    handleSortChange({ order }) {
      this.orderType = order === "descending" ? "baoMingEndDate_down" : order === "ascending" ? "baoMingEndDate_up" : "default"
      this.getList("0")
    }
  }
};
</script>

<style scoped lang="scss">
.purchase-block{
  width: 100%;
  height: 404px;
	.purchase-block-header{
		width: 100%;
		height: 41px;
		color: #333;
		background-color: #fff;
		border-bottom: 1px solid $--color-primary;
		h4{
			width: 120px;
			color: #fff;
			padding-left: 40px;
			line-height: 40px;
			font-size: 16px;
			font-weight: normal;
			background: linear-gradient(
							to right,
							$--color-primary 0%,
							$--color-primary calc(100% - 10px),
							rgba(220, 75, 25, 0.3) calc(100% - 10px),
							rgba(220, 75, 25, 0.3) 100%
			) no-repeat;
			position: relative;
			&:after{
				content: '';
				display: block;
				position: absolute;
				left: 10px;
				top: 50%;
				transform: translateY(-50%);
				background: no-repeat center / contain;
			}
			&.GC:after{
				width: 21px;
				height: 21px;
				background-image: url("@/assets/images/home/purchase-icon-gc.png");
			}
			&.FW:after{
				width: 24px;
				height: 24px;
				background-image: url("@/assets/images/home/purchase-icon-fw.png");
			}
			&.HW:after{
				width: 21px;
				height: 26px;
				background-image: url("@/assets/images/home/purchase-icon-hw.png");
			}
			&.QT:after{
				width: 22px;
				height: 22px;
				background-image: url("@/assets/images/home/purchase-icon-qt.png");
			}
		}
		ul > li {
			font-size: 14px;
			cursor: pointer;
			&.active{
				color: $--color-primary;
			}
		}
	}
	.list{
		flex: 1;
		min-height: 0;
		border: 1px solid #ddd;
		.project-table {
			&::before{
				height: 0;
			}
			.table-btn {
				width: 70px;
				height: 24px;
				color: #fff;
				text-align: center;
			}
		}
	}
}
</style>
